/**
 * Страница пользователя: коллажи комнаты (user/room-collages).
 *
 * Маркер инициализации — #export-collages-form (уникален странице).
 * Конфиг — window.roomCollagesConfig.
 *
 * Функционал:
 *   - открытие ProductSelectionModal с контекстом 'collage';
 *   - добавление товара в комнату (AJAX) + reload;
 *   - удаление товара (через showConfirmation);
 *   - экспорт выбранных коллажей.
 */

function init() {
    if (!document.getElementById('export-collages-form')) return;

    const config = window.roomCollagesConfig;
    if (!config) {
        console.error('[room-collages] window.roomCollagesConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[room-collages] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};
    const showConfirmation = window.showConfirmation;

    $(() => {
        $('#add-product-btn').on('click', function () {
            const ProductSelectionModal = window.ProductSelectionModal;
            if (!ProductSelectionModal) {
                console.error('[room-collages] ProductSelectionModal is not loaded');
                return;
            }
            ProductSelectionModal.open({
                context: 'collage',
                data: { roomId: config.roomId, projectId: config.projectId },
                onSelect: addProductToRoom,
            });
        });

        function addProductToRoom(result) {
            const product = result.product;
            const sizeIndex = result.sizeIndex;
            const quantity = result.quantity || 1;

            $.ajax({
                url: config.routes.addProduct,
                method: 'POST',
                data: {
                    _token: config.csrfToken,
                    project_id: config.projectId,
                    product_id: product.id,
                    size_index: sizeIndex,
                    quantity,
                },
                success() {
                    window.location.reload();
                },
                error(xhr) {
                    let errorMessage = config.i18n.errorAddingProduct;
                    if (xhr.responseJSON && xhr.responseJSON.message) {
                        errorMessage += ': ' + xhr.responseJSON.message;
                    } else if (xhr.status === 500) {
                        errorMessage += ': Server error';
                    }
                    showToast('error', errorMessage);
                },
            });
        }

        $('.cell_adm_collages_delete').on('click', function (e) {
            e.preventDefault();
            const productId = $(this).data('product-id');
            if (typeof showConfirmation !== 'function') return;
            showConfirmation(config.i18n.confirmDeleteProduct).then(confirmed => {
                if (!confirmed) return;
                $.ajax({
                    url: '/room/' + config.roomId + '/product/' + productId,
                    type: 'DELETE',
                    data: { _token: config.csrfToken },
                    success() { window.location.reload(); },
                    error() {
                        showToast('error', config.i18n.errorRemovingProduct);
                        window.location.reload();
                    },
                });
            });
        });

        $('#export-selected-btn').on('click', function () {
            const selectedIds = [];
            $('.collage-checkbox:checked').each(function () {
                selectedIds.push($(this).val());
            });
            if (selectedIds.length === 0) {
                showToast('warning', config.i18n.noCollagesSelected);
                return;
            }
            $('#export-collage-ids').val(JSON.stringify(selectedIds));
            $('#export-collages-form').submit();
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
